<template>
  <div class="car-brands">
    <div class="car-brands__purpose">
      <!-- 标题区域 -->
      <div class="car-brands__title">
        <div class="car-brands__heading">Browse by Brands</div>
        <a :href="allCarsLink" class="car-brands__view">
          <div class="car-brands__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-brands__icon" alt="">
        </a>
      </div>

      <!-- 品牌卡片区域：PC端每行5个，移动端每行2个 -->
      <div class="car-brands__cards"
        :class="{'car-brands__cards--mobile': deviceType === 'mobile'}">
        <a v-for="(brand, index) in carBrands" :key="`brand-${index}`" class="car-brands__card"
          :href="getBrandLink(brand.value)">
          <img :src="brand.logo" class="car-brands__card-logo" alt="">
          <div class="car-brands__card-name">{{ brand.name }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import navigationMixin from '@/mixin/navigationMixin.js';

export default {
  name: 'CarBrands',
  mixins: [navigationMixin],
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    }),
    allCarsLink () {
      return this.getCarListUrl(this.$route.query);
    }
  },
  data () {
    return {
      carBrands: [
        {
          name: 'Toyota',
          value: 'Toyota',
          logo: require('@/assets/brands/toyota.png')
        },
        {
          name: 'Volkswagen',
          value: 'Volkswagen',
          logo: require('@/assets/brands/volkswagen.png')
        },
        {
          name: 'Hyundai',
          value: 'Hyundai',
          logo: require('@/assets/brands/hyundai.png')
        },
        {
          name: 'Audi',
          value: 'Audi',
          logo: require('@/assets/brands/audi.png')
        },
        {
          name: 'Nissan',
          value: 'Nissan',
          logo: require('@/assets/brands/nissan.png')
        },
        {
          name: 'Chevrolet',
          value: 'Chevrolet',
          logo: require('@/assets/brands/chevrolet.png')
        },
        {
          name: 'Ford',
          value: 'Ford',
          logo: require('@/assets/brands/ford.png')
        },
        {
          name: 'Honda',
          value: 'Honda',
          logo: require('@/assets/brands/honda.png')
        },
        {
          name: 'BMW',
          value: 'BMW',
          logo: require('@/assets/brands/bmw.png')
        },
        {
          name: 'Mercedes-Benz',
          value: 'Mercedes-Benz',
          logo: require('@/assets/brands/mercedes.png')
        },
      ]
    }
  },
  methods: {
    getBrandLink (brand) {
      if (!brand) return '#';
      const query = { ...this.$route.query, brand };
      return this.getCarListUrl(query);
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-brands {
	background: #ffffff;
	padding: rem(50) rem(120);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;

	&__purpose {
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		position: relative;
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #050b20;
		text-align: left;

		font-size: rem(24);
		line-height: rem(24);
		font-weight: 900;
		position: relative;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(10);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 500;
		color: #405ff2;
	}

	&__icon {
		flex-shrink: 0;
		width: rem(14);
		height: rem(14);
		position: relative;
		overflow: visible;
	}

	&__cards {
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		align-self: stretch;
		position: relative;

		// 移动端样式 - 两个一行
		&--mobile {
			gap: rem(16);

			.car-brands__card {
				flex: 0 0 calc(50% - rem(8));
				max-width: calc(50% - rem(8));
			}
		}
	}

	&__card {
		// width: rem(216);
		height: rem(144);
		padding: rem(21) rem(18);
		display: flex;
		flex: 0 0 calc((100% - rem(120)) / 5); /* 使每个子元素占1/3的宽度 */
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: rem(20);
		border-radius: rem(12);
		border: 1px solid #e9e9e9;
		background: #f9fbfc;
		transition: all 0.3s ease;
		cursor: pointer;

		&:hover {
			box-shadow: 0 rem(4) rem(12) rgba(0, 0, 0, 0.08);
			border-color: #d0d0d0;
		}
	}

	&__card-logo {
		max-width: 100%;
		max-height: rem(60);
		object-fit: contain;
		position: relative;
	}

	&__card-name {
		color: #050b20;
		text-align: center;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 400;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-brands {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-brands {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(30) rem(16);

		&__purpose {
			width: 100%;
		}

		&__heading {
			font-size: rem(20);
			line-height: rem(20);
		}

		&__view-all {
			font-size: rem(14);
			line-height: rem(14);
		}

		&__icon {
			width: rem(14);
			height: rem(14);
		}
	}
}
</style> 